import {createSlice} from "@reduxjs/toolkit";
import {dynamicLocalStoreKey} from "./dynamic.reducer";
import {Keys} from "../../common/constants";

export const initialState = {
    user: null,
    tenantID: null,
    isAdmin: false,
    accessToken: null,
    refreshToken: null
}
export const localStoreKey = Keys.COMMON;
export const localStoreKeyAccessToken = Keys.ACCESS_TOKEN
export const localStoreKeyRefreshToken = Keys.REFRESH_TOKEN

const authorizationSlice = createSlice({
    name: 'authorization',
    initialState,
    reducers: {
        logOut: (state?: any) => {
            state.user = null;
            state.accessToken = null;
            state.refreshToken = null;
            state.tenantID = null;
            state.isAdmin = false;
            localStorage.removeItem(localStoreKey);
            localStorage.removeItem(dynamicLocalStoreKey);
            localStorage.removeItem(localStoreKeyAccessToken);
            localStorage.removeItem(localStoreKeyRefreshToken);
        },
        uploadUser: (state, action) => {
            state.user = action.payload;
        },
        setAuthorization: (state: any, action) => {
            const {user, tenantID, isAdmin, accessToken, refreshToken} = action.payload;

            localStorage.setItem(localStoreKey, JSON.stringify({
                user,
                tenantID,
                isAdmin
            }));
            state.user = user
            state.tenantID = tenantID
            state.isAdmin = isAdmin
            state.accessToken = accessToken;
            state.refreshToken = refreshToken;

            localStorage.setItem(localStoreKeyAccessToken, state.accessToken || '');
            localStorage.setItem(localStoreKeyRefreshToken, state.refreshToken || '');
        },
        setTokens: (state: any, action) => {
            state.accessToken = action.payload.accessToken;
            state.refreshToken = action.payload.refreshToken;

            localStorage.setItem(localStoreKeyAccessToken, state.accessToken || '');
            localStorage.setItem(localStoreKeyRefreshToken, state.refreshToken || '');
        },
        getTokens: (state: any): any => {
            return {
                accessToken: state.accessToken,
                refreshToken: state.refreshToken
            }
        }
    },
})

export default authorizationSlice.reducer

export const {
    setTokens,
    getTokens,
    logOut,
    uploadUser,
    setAuthorization
} = authorizationSlice.actions
